import port1 from "../Assets/portImages/maya-1.jpg";
// import port2 from "../Assets/portImages/port1.jpg";
// import port3 from "../Assets/portImages/port2.jpg";
// import port4 from "../Assets/portImages/port3.jpg";
// import port6 from "../Assets/portImages/port5.jpg";
// import port7 from "../Assets/portImages/port6.jpg";

const portfolios = [
  {
    id: 1,
    category: [
      "React.js",
      "JavaScript",
      "Python",
      "Flask",
      "Docker",
      "MongoDB",
      "HTML",
      "CSS",
    ],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/airbnb-clone",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "AirBnB Clone",
  },
  {
    id: 2,
    category: ["React.js", "JavaScript", "Firebase", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/instagram-clone",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Instagram Clone",
  },
  {
    id: 3,
    category: ["Python", "Matplotlib", "Pandas"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/classify-authors-on-writing-style",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Lexicographic classification of Authors",
  },
  {
    id: 4,
    category: ["Express.js", "React.js", "JavaScript", "PgSQL", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/face-detection-API",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Face Detection API",
  },
  {
    id: 5,
    category: ["Python", "Flask"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/lyft-challenge",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Crop Strings API (Lyft)",
  },
  {
    id: 6,
    category: ["JavaScript", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/cut-copy-paste-clipboard",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Clipboard Simulation",
  },
  {
    id: 7,
    category: ["MongoDB", "Flask", "Python", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/API-Finder-MongoDB-Flask",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "API Finder",
  },
  {
    id: 8,
    category: ["Python", "Flask", "SQLite3", "Pandas", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/horseRacing-restAPI-Flask",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Derby Betting System",
  },
  {
    id: 9,
    category: ["Twilio"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/send-sms-twilio",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Send SMS",
  },
  {
    id: 10,
    category: ["Matplotlib", "Python", "NumPy", "OpenCV"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/OpenCV-Bag-of-Words",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Bag of Words Model",
  },
  {
    id: 11,
    category: ["Python", "Pytorch", "openCV", "NumPy"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/Action-Recognition-Pytorch",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Action Recognition",
  },
  {
    id: 12,
    category: ["Python", "Pytorch", "openCV", "NumPy", "Pandas"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/Object-Detection-Pytorch",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Object Detection",
  },
  {
    id: 13,
    category: ["Python", "SQL"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/leetcode",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Leetcode",
  },
  {
    id: 14,
    category: ["JavaScript", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/progress-bar-component",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Progress Bar",
  },
  {
    id: 15,
    category: ["Java", "JavaScript", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/railrakshak",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "online FIR System",
  },
  {
    id: 16,
    category: ["React.js", "JavaScript", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/react-target-sum-app",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Target Sum",
  },
  {
    id: 17,
    category: ["React.js", "JavaScript", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/Fetch-GitHub-Users",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Fetch GitHub Users",
  },
  {
    id: 18,
    category: ["Python", "Pandas", "Seaborn", "Matplotlib"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/Test_COVID_Risk_wrt_Weather",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "COVID Risk wrt Weather",
  },
  {
    id: 19,
    category: ["HTML", "CSS", "JavaScript", "Firebase"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/firebase-prototype-app",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Firebase Meetup App",
  },
  {
    id: 20,
    category: ["Python", "Flask", "HTML", "CSS"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/transcribeTextToSpeech",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Text to Speech",
  },
  {
    id: 21,
    category: ["Python", "OpenCV"],
    link1:
      "https://github.com/delzadbamji/work-in-progress-template/blob/main/README.md",
    link2: "https://github.com/delzadbamji/Computer-vision-101",
    icon1: "YouTube",
    icon2: "Github",
    image: port1,
    title: "Computer Vision 101",
  },
];

export default portfolios;
